export default __webpack_public_path__ + "static/media/Counter.11bd4d1b.svg";